import React from 'react'

import { DeviceType, useDeviceType } from '@library/dom'

import { CUSTOMER_REVIEWS } from '../../../config'
import { Carousel, type CarouselProps } from '../../EndlessVarietySection/Carousel'
import { CWCReviewsCard } from './CWCReviewsCard'
import { Box } from '@gousto-internal/citrus-react'
import { LandingPageContentSections } from '../../../tracking'

// Forked from CustomerReviewsSection/components/ReviewsCarousel for this section only —
// renders the local ReviewsCard (corrected box-shadow) instead of the shared one.
const propertiesForTracking = {
  carouselSection: LandingPageContentSections.HOMEPAGE_REVIEWS,
}

export const CWCReviewsCarousel = () => {
  const deviceType = useDeviceType()
  const isMobileDevice = deviceType === DeviceType.MOBILE
  const isDesktopDevice = deviceType === DeviceType.DESKTOP
  const carouselWrapperStyle = deviceType === DeviceType.TABLET ? { paddingLeft: '8px' } : undefined
  let carouselOptions: CarouselProps['options']

  if (isDesktopDevice) {
    carouselOptions = {
      align: 'center' as const,
      containScroll: 'trimSnaps',
      loop: false,
    }
  } else if (isMobileDevice) {
    carouselOptions = { align: 'start' as const, loop: false }
  } else {
    carouselOptions = { align: 'center' as const, loop: true }
  }

  return (
    <Box data-testid="reviews-carousel" style={carouselWrapperStyle}>
      <Carousel
        carouselAreaLabel="reviewsCarousel"
        options={carouselOptions}
        slidePaddingH={2}
        slidePaddingV={1}
        showNavButtons={!isMobileDevice}
        autoHideNavButtons
        startAtMiddleAvailableSnap={isDesktopDevice}
        centerSlidesWhenNotScrollable={isDesktopDevice}
        snowplowTrackingProperties={propertiesForTracking}
      >
        {CUSTOMER_REVIEWS.review.map(({ quote, reviewer }, index) => (
          // The card's drop shadow extends ~24px below it; the shared Carousel clips overflow on
          // both axes, so pad the slide's bottom to keep the shadow from being cut.
          <Box key={`${reviewer}-${index}`} paddingBottom={8}>
            <CWCReviewsCard quote={quote} reviewer={reviewer} />
          </Box>
        ))}
      </Carousel>
    </Box>
  )
}
